export default "__VITE_ASSET__5361347b__"